import config from './config';
import type { Config } from './config.type';
declare global {
	interface Window {
		appKey: string;
		version: string;
		config: Config;
	}
}

console.log(`CONFIG`, config);
window.appKey = config.build.appKey;
window.version = config.build.version;
window.config = config;

export default config;
